import { observer } from "mobx-react-lite"
import React, { useContext } from 'react'
import { toastSuccess } from "../../FormComponents/Toasts"
import Modal from "../../Modal/Modal"
import { Formik, Form } from 'formik'
import ReactSelect from "../../FormComponents/ReactSelect"
import axiosService from "../../../utils/AxiosService"
import { useNavigate, useParams } from "react-router-dom"
import { BrowseContext } from "../../../contexts/BrowseContext"

export default observer(function UpdateCampaignFolderModal() {
  const { browseState, folders } = useContext(BrowseContext)
  const { client_id } = useParams()
  const navigate = useNavigate()
  
  const folderOptions = folders
    .filter(folder => folder.client_id === +client_id)
    .map(folder => ({ label: folder.name, value: folder.id }))

  const handleUpdate = (values) => {
    browseState.updateCampaignFolder(values.folder_id)
  }

  return (
    <Modal isOpen={browseState.openUpdateCampaignFolder} onClose={() => browseState.toggleUpdateCampaignFolder()}>
      <Modal.Header>
        <h2 className='text-lg font-bold'>Update Campaign Folder</h2>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{
            folder_id: ''
          }}
          onSubmit={handleUpdate}
        >
          {({ setFieldValue, handleBlur, values, touched, errors }) => (
            <Form className='w-[400px]'>
              <div className="mt-3 mx-auto w-full">
                <ReactSelect
                  error={touched.folder_id && errors.folder_id}
                  noLabelPadding
                  label="Folder"
                  name='folder_id'
                  options={folderOptions}
                  value={values.folder_id}
                  onChange={(folder_id) => setFieldValue('folder_id', folder_id.value, true)}
                  onBlur={handleBlur}
                />
              </div>

              <div className="flex justify-between mt-5">
                <button
                  type='button'
                  className='rb-btn-cancel font-bold text-md ml p-2 px-4 rounded-lg'
                  onClick={() => browseState.toggleUpdateCampaignFolder()}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="ml-auto bg-rb-green text-white rounded-lg p-2 px-4 submit text-center active:shadow-outer active:shadow-rb-green border-rb-green"
                >
                  Update
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}) 